//Implement multiple tabs which you can click to switch between different content
export class Tabs {
    private buttons!:JQuery<HTMLElement>;
    private pages!:JQuery<HTMLElement>;

    private static instances:Tabs[]=[];
    private EventKeys = [
        "Enter",
        " ",
        "ArrowLeft",
        "ArrowRight"
    ];

    constructor (private container:JQuery) {
        for (var inst of Tabs.instances) {
            if (inst.container.is(container)) return inst;
        }

        this.container.find('.tabs-list').attr('role','tablist');
        this.buttons = this.container.find('.tabs-tab');
        this.pages = this.container.find('.tabs-pane');

        for (let button of this.buttons) {
            let idx = $(button).index();
            let elementID = this.getUniqueID();
            $(button).attr('id', elementID).attr('role','tab');
            $(this.pages[idx]).attr('aria-labelledby',elementID).attr('role','tabpanel');
        }

        this.buttons.on('click keydown',(ev)=>this.changeTabEvent(ev));

        Tabs.instances.push(this);
    }

    private changeTabEvent(ev:JQuery.TriggeredEvent) {
        if(ev.type == 'keydown' && !this.EventKeys.includes(ev.key??'')) return;
        ev.preventDefault();
        let btn = $(ev.target);
        let idx = btn.index();

        if (ev.type == 'keydown') {
            if (ev.key == 'ArrowLeft') {
                idx--;
                if (idx < 0) idx = this.buttons.length - 1;
            };
            if (ev.key == 'ArrowRight')  {
                idx++;
                if (idx >= this.buttons.length) idx = 0;
            };
        }

        btn = this.buttons.eq(idx);
        btn.focus();
        btn.addClass("active").attr('aria-selected',"true");
        this.buttons.not(btn).removeClass("active").attr('aria-selected',"false");
        let page = this.pages.eq(idx);
        this.pages.not(page).removeClass("active");
        page.addClass("active");
        let tab=btn.attr('data-tab');
        if (tab) this.container.attr('data-tab',tab);
    }

    private getUniqueID():string {
        return 'tabs-' + Math.random().toString(16).slice(2);
    }
}

export {};